import { useTranslation } from 'react-i18next'
import { compareDesc } from 'date-fns'
import { useEffect, useState } from 'react'
import { getArtifactEvents } from '../../services/artifactService'
import useNotifications from '../useNotifications'

/**
 * Hook for fetching recent events for an artifact
 * @param {number} artifactId artifact to fetch events for
 * @returns {Object} object with loading boolean, error status/data, events array, and refetch function
 */
const useArtifactEvents = (artifactId, shouldExecute) => {
  const { t } = useTranslation()
  const [events, setEvents] = useState(null)
  const [refetch, setRefetch] = useState(true)
  const { error } = useNotifications()

  useEffect(() => {
    if (shouldExecute) {
      getArtifactEvents(artifactId)
        .then((response) => {
          const eventItems = response.data.items || []
          eventItems.forEach((event) => {
            event.date = new Date(event.eventDateTime)
          })
          eventItems.sort((a, b) => compareDesc(a.date, b.date))
          setEvents(eventItems)
        })
        .catch((err) => {
          error(t('hooks.errors.retrievingArtifact', `Error retrieving artifact`), err)
        })
    }
  }, [artifactId, error, refetch, shouldExecute, t])

  const refetchArtifactsEvents = () => setRefetch(!refetch)

  return {
    events,
    refetchArtifactsEvents,
  }
}

export default useArtifactEvents
